import template from './templates/ktFlightRoute.tmpl.html';

export default function FlightRoute(tripUtils) {
    'ngInject';

            return {
                restrict: 'AE',
                template,
                scope: {
                    flight: '=',
                    showOnlyValue: '@?',
                    forFlightGroupIndex: '=?',
                },
                bindToController: true,
                controller: flightRouteCtrl,
                controllerAs: 'flightRouteCtrl',
            };

            function flightRouteCtrl() {
                const vm = this;

                activate();

                function activate() {
                    if (angular.isUndefined(vm.forFlightGroupIndex)) {
                        vm.flightRoute = getFlightRoute(vm.flight.FlightGroups);
                    } else {
                        vm.flightRoute = getFlightRoute([vm.flight.FlightGroups[vm.forFlightGroupIndex]]);
                    }

                    vm.showFullInfo = !vm.showOnlyValue;
                }

                function getFlightRoute(flightGroups) {
                    const flightRoute = tripUtils.collectAllDestinationsDataForFlight(flightGroups);
                    return _.reduce(flightRoute, function(routePoints, routePoint) {
                        if (!isCitySameAsPrevious(routePoints, routePoint)) {
                            routePoints.push(routePoint);
                        }
                        return routePoints;
                    }, []);
                }

                function isCitySameAsPrevious(routePoints, routePoint) {
                    return routePoints[routePoints.length - 1]
                        && routePoints[routePoints.length - 1].airportCode === routePoint.airportCode;
                }
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/directives/ktFlightRoute.directive.js